// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress {
  height: 8px;
  background: black;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25), 0 1px rgba(255, 255, 255, 0.08);
}

.progress-bar {
  height: 8px;
  background-color: #ee303c;
  border-radius: 4px;
  transition: 0.4s linear;
  transition-property: width, background-color;
}

.progress-bar3 {
  height: 8px;
  border-radius: 0;
  transition: 0.4s linear;
  transition-property: width, background-color;
}

.progress-infinite .progress-bar3 {
  height: 8px;
  position: absolute;
  top: 0;
  right: 100%;
  bottom: 0;
  left: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.589), red, rgba(0, 0, 0, 0.589));
  width: 0;
  animation: borealisBar 1s linear infinite;
}

@keyframes borealisBar {
  0% {
    left: 0%;
    right: 100%;
    width: 0%;
  }
  10% {
    left: 0%;
    right: 75%;
    width: 25%;
  }
  90% {
    right: 0%;
    left: 75%;
    width: 25%;
  }
  100% {
    left: 100%;
    right: 0%;
    width: 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/loader/loader.component.scss","webpack://./../../Universo%20Tunning/ecommerce/src/app/components/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,gFAAA;ACCF;;ADGA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,4CAAA;ACAF;;ADGA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,4CAAA;ACAF;;ADGA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,sFAAA;EACA,QAAA;EACA,yCAAA;ACAF;;ADGA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;ECAF;EDEA;IACE,QAAA;IACA,UAAA;IACA,UAAA;ECAF;EDEA;IACE,SAAA;IACA,SAAA;IACA,UAAA;ECAF;EDEA;IACE,UAAA;IACA,SAAA;IACA,SAAA;ECAF;AACF","sourcesContent":[".progress {\n  height: 8px;\n  background: black;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25),\n    0 1px rgba(255, 255, 255, 0.08);\n}\n\n.progress-bar {\n  height: 8px;\n  background-color: #ee303c;\n  border-radius: 4px;\n  transition: 0.4s linear;\n  transition-property: width, background-color;\n}\n\n.progress-bar3 {\n  height: 8px;\n  border-radius: 0;\n  transition: 0.4s linear;\n  transition-property: width, background-color;\n}\n\n.progress-infinite .progress-bar3 {\n  height: 8px;\n  position: absolute;\n  top: 0;\n  right: 100%;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.589), red, rgba(0, 0, 0, 0.589));\n  width: 0;\n  animation: borealisBar 1s linear infinite;\n}\n\n@keyframes borealisBar {\n  0% {\n    left: 0%;\n    right: 100%;\n    width: 0%;\n  }\n  10% {\n    left: 0%;\n    right: 75%;\n    width: 25%;\n  }\n  90% {\n    right: 0%;\n    left: 75%;\n    width: 25%;\n  }\n  100% {\n    left: 100%;\n    right: 0%;\n    width: 0%;\n  }\n}\n",".progress {\n  height: 8px;\n  background: black;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25), 0 1px rgba(255, 255, 255, 0.08);\n}\n\n.progress-bar {\n  height: 8px;\n  background-color: #ee303c;\n  border-radius: 4px;\n  transition: 0.4s linear;\n  transition-property: width, background-color;\n}\n\n.progress-bar3 {\n  height: 8px;\n  border-radius: 0;\n  transition: 0.4s linear;\n  transition-property: width, background-color;\n}\n\n.progress-infinite .progress-bar3 {\n  height: 8px;\n  position: absolute;\n  top: 0;\n  right: 100%;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.589), red, rgba(0, 0, 0, 0.589));\n  width: 0;\n  animation: borealisBar 1s linear infinite;\n}\n\n@keyframes borealisBar {\n  0% {\n    left: 0%;\n    right: 100%;\n    width: 0%;\n  }\n  10% {\n    left: 0%;\n    right: 75%;\n    width: 25%;\n  }\n  90% {\n    right: 0%;\n    left: 75%;\n    width: 25%;\n  }\n  100% {\n    left: 100%;\n    right: 0%;\n    width: 0%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
